import VoucherPartnerVehicleListView from "features/ManageVoucherPartner/VoucherPartner/components/VoucherPartnerVehicleListView";

VoucherPartnerVehicleListScreen.propTypes = {};

function VoucherPartnerVehicleListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <VoucherPartnerVehicleListView showFullUI={true} />
            </div>
        </div>
    );
}

export default VoucherPartnerVehicleListScreen;
